import {Component, EventEmitter, Output, ViewContainerRef} from '@angular/core';
import {Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Configuration} from '../../shared/services/configuration';
import {HttpClientCustom} from '../../shared/services/http.client';
import * as _ from 'underscore';
import {Auth} from '../shared/services/auth';
import {SharedData} from '../../shared/sharedData';
import {AppComponent} from '../../../app.component';
import {ActionSuspend} from './employeeActions/actionSuspend';
import {ToasterComponent} from '../../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'operation',
    templateUrl: 'operationComponent.html',
    inputs: ['operation', 'i'],
})
export class OperationComponent {
    public operation;
    public i;
    public _baseUrl: any;
    public showChild: boolean = false;
    public hasChild: boolean = true;
    public asl: boolean = false;
    public result: any;
    public childOperations;
    public answer: any;
    public pushEvent: any = { isSelected: null, selectedOperation: null };
    public eventStatus: any;


    @Output() deleteOrgEvent = new EventEmitter<number>();
    @Output() selected = new EventEmitter();
    constructor(
        public _global: Configuration,
        public http: HttpClientCustom, public router: Router,
        public _toaster: ToasterComponent,
        public modalService: NgbModal,
        public activeModal: NgbActiveModal,
        public share: SharedData,
        public translate:TranslateService,
        vcr: ViewContainerRef) {
        this._baseUrl = _global.get("EPMS_BASE_URL");
    }

    public hasChilds() {
        return this.operation.childOperations != null && this.operation.childOperations.length > 0;
    }

    public toggleChild() {
        let self = this;
        if (self.operation.childOperations) {
            self.showChild = !self.showChild;
        }
    }
    checkIfAllSelected(i, e) {
        
        let that = this;
        that.selected.emit(i);
        if (i.childOperations.length > 0) {
            _.each(i.childOperations, function (key, val) {
                key.assigned = e;
                that.selected.emit(key);
            });
        } else {
            that.selected.emit(i);
        }

    }
    select(i) {
        this.selected.emit(i);
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/rolesAndPermission/operationComponent.ts